import { URL, handleErrors } from "./depannageActions"
import { showToast } from "./toastActions"
import { catchApiError } from "./apiHelpers"

//////////////////////////////////////////////////////////////
//        Diagnostiques (arbre + tarifs par assistance)     //
//////////////////////////////////////////////////////////////
// L'arbre arrive du backend déjà groupé par parent :
// { "-1": [menus rapides], "0": [racines], "<parentId>": [enfants] }.
// Les tarifs par assistance : { "<diagId>": { "<entiteId>": {tarif, ...} } }.
// POST/DELETE renvoient la structure fraîche → on redispatch le SUCCESS du
// fetch, comme les secteurs police.

export const FETCH_DIAGNOSTIQUES_BEGIN = "FETCH_DIAGNOSTIQUES_BEGIN"
export const FETCH_DIAGNOSTIQUES_ERROR = "FETCH_DIAGNOSTIQUES_ERROR"
export const FETCH_DIAGNOSTIQUES_SUCCESS = "FETCH_DIAGNOSTIQUES_SUCCESS"
export const FETCH_DIAG_TARIFS_SUCCESS = "FETCH_DIAG_TARIFS_SUCCESS"

export const fetchDiagnostiquesSuccess = (tree) => ({
	type: FETCH_DIAGNOSTIQUES_SUCCESS,
	payload: { tree },
})

export const fetchDiagTarifsSuccess = (tarifs) => ({
	type: FETCH_DIAG_TARIFS_SUCCESS,
	payload: { tarifs },
})

export function fetchDiagnostiques() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_DIAGNOSTIQUES_BEGIN })
		return fetch(`${URL}api/diagnostiques`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchDiagnostiquesSuccess(json)))
			.catch(
				catchApiError(dispatch, (error) => ({
					type: FETCH_DIAGNOSTIQUES_ERROR,
					payload: { error },
				})),
			)
	}
}

export function fetchDiagTarifs() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/diag_tarifs`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchDiagTarifsSuccess(json)))
			.catch(catchApiError(dispatch))
	}
}

export function postDiagnostique(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/diagnostiques`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDiagnostiquesSuccess(json))
				dispatch(showToast("success", "Diagnostic enregistré"))
			})
			.catch(catchApiError(dispatch))
	}
}

export function deleteDiagnostique(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/diagnostiques`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDiagnostiquesSuccess(json))
				dispatch(showToast("success", "Diagnostic supprimé"))
			})
			.catch(catchApiError(dispatch))
	}
}

export function postDiagTarif(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/diag_tarifs`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDiagTarifsSuccess(json))
				dispatch(showToast("success", "Tarif assistance enregistré"))
			})
			.catch(catchApiError(dispatch))
	}
}

export function deleteDiagTarif(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/diag_tarifs`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: kwargs,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDiagTarifsSuccess(json))
				dispatch(showToast("success", "Tarif assistance supprimé"))
			})
			.catch(catchApiError(dispatch))
	}
}
